import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { H6, Image, SVG } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VariationRadios } from "../../../../Constant";
import { VARIATION_RADIO, VARIATION_RADIO_DATA } from "../../../../Data/FormControl/MegaOptions";
import { VariationRadioProp } from "../../../../Type/FormValidation";

const VariationRadio = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={VariationRadios} span={VARIATION_RADIO} />
        <CardBody>
          <Row className="g-3">
            {VARIATION_RADIO_DATA.map(({ colClass, title, child }, index) => (
              <Col xl="4" className={colClass ? colClass : ""} key={index}>
                <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
                  <H6 className="sub-title">{title}</H6>
                  {child.map(({ id, labelText, image, icon, name, defaultChecked, iconColor }:VariationRadioProp) => (
                    <div className="payment-wrapper" key={id}>
                      <div className="payment-first">
                        <FormGroup className="radio radio-primary" check>
                          <Input id={`ptm${id}`} type="radio" name={name} value="option1" defaultChecked={defaultChecked} /><Label className="mb-0" htmlFor={`ptm${id}`} check>{labelText}</Label>
                        </FormGroup>
                      </div>
                      {(image || icon) && (
                        <div className="payment-second">
                          {image && <Image className="img-fluid" src={image} alt="ecommerce" />}
                          {icon && <SVG className={`mega-icons stroke-${iconColor}`} iconId={icon} />}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VariationRadio;
